import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { Router, RouterLinkActive, RouterLink, RouterOutlet } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { Observable, Subscription, timer } from "rxjs";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { EntityBase } from "../../entity/EntityBase";
import { MatTabGroup, MatTabNav, MatTabLink, MatTabNavPanel } from "@angular/material/tabs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Pair } from "../../obj/Pair";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { HeaderComponent } from "../incs/header.component";
import { MatBadge } from "@angular/material/badge";

@Component({
    selector: "kilowant-seller-home",
    templateUrl: "../../../html/seller/main-seller-home.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, MatTabNav, MatTabLink, RouterLinkActive, RouterLink, MatBadge, MatTabNavPanel, RouterOutlet]
})

export class SellerHomeComponent extends AbstractSellerComponent {
    @ViewChild("tabs") tabGroup: MatTabGroup = null!;

    highlightSubscription: Subscription;
    navLinks: any[];
    activeLinkIndex = 0;

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) {
        super(router, route, dialog, authService, analyticsService, generalService);
        this.navLinks = [
            {
                id: "SellOffer",
                label: "Seller Offers",
                link: "/seller/home/sell-offers",
                highlight: 0,
                index: 0
            }, {
                id: "BuyerOrders",
                label: "Buyer Orders",
                link: "/seller/home/buy-offers",
                highlight: 0,
                index: 1
            }, {
                id: "Contract",
                label: "Accepted Offers",
                link: "/seller/home/accepted-offers",
                highlight: 0,
                index: 2
            }
        ];
    }

    ngOnInit(): void {
        this._reloadHighlights();
        this.highlightSubscription = this.generalService.changeHighlightedActivities$.subscribe(
            x => {
                this._reloadHighlights();
            });
    }

    ngOnDestroy() {
        if (this.highlightSubscription != null) {
            this.highlightSubscription.unsubscribe();
        }
    }

    _reloadHighlights(): void {
        this.generalService.getHighlights()
            .then(h => {
                for (var i = 0; i < this.navLinks.length; i++) {
                    this.navLinks[i].highlight = h[this.navLinks[i].id] ?? 0;
                }
                if (this.router.url == "/seller/home") {
                    this.router.navigate([this.navLinks[0].link]);
                }
                this.cdr.detectChanges();
            });
    }

}